import React from 'react'
import { RefContextLanguage } from '../providers/LanguageProvider'
import { SymbolForStatus } from '../community-hats-js-library/utils/devicesStatusFunctions'
import CustomText from './CustomText'
import * as locCon from "../LocalConstants"
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions'

function CollectionStatus({ status, message, title }) {

    const i18n = RefContextLanguage()


    return (
        <div className='verticalSection'>
            <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: "1vh" }}>{isNullOrUndefined(title) ? i18n.t("collectionStatus") : title}</CustomText>
            <SymbolForStatus status={status} message={message} size={28} translation={(v) => i18n.t(v)} />
            <CustomText type={locCon.INFO_TEXT} style={{ marginBottom: "1.5vh" }}>{i18n.t(message)}</CustomText>
        </div>
    )
}

export default CollectionStatus